import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { ReportSource } from "../../../api/models";
import { ReportExportService } from "../../../api/services";

export interface EditReportSourceDialogData {
  dialogTitle: string;
  reportSource: ReportSource;
}

@Component({
  selector: "edit-report-source-dialog",
  styleUrls: ["edit-report-source-dialog.component.css"],
  templateUrl: "./edit-report-source-dialog.component.html",
})
export class EditReportSourceDialogComponent {
  public Result: DialogResult;
  public fileToUpload: File = null;
  public uploadingReportSource: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditReportSourceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReportSourceDialogData,
    private reportExportService: ReportExportService
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {

    this.uploadingReportSource = true;

    const callParams: ReportExportService.ReportExportCreateReportSourceParams = {
      upload: this.fileToUpload,
      reportSourceReportSourceId: this.data.reportSource.reportSourceId,
      reportSourceName: this.data.reportSource.name,
      reportSourceFileName: this.data.reportSource.fileName,
      reportSourceFileId: this.data.reportSource.fileId,
      reportSourceDescription: this.data.reportSource.description,
      PreFilterCompanyAvailable: this.data.reportSource.preFilterCompanyAvailable,
      PreFilterIndustryAvailable: this.data.reportSource.preFilterIndustryAvailable,
      PreFilterOccupationAvailable: this.data.reportSource.preFilterOccupationAvailable,
      PreFilterRegionAvailable: this.data.reportSource.preFilterRegionAvailable,
      PreFilterTitleAvailable: this.data.reportSource.preFilterTitleAvailable,
      Active: this.data.reportSource.active
    };

    if (this.data.reportSource.reportSourceId == -1) {
      this.reportExportService
        .reportExportCreateReportSource(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => {
          alert(error.error);
        }
      );
    } else {
      this.reportExportService
        .reportExportUpdateReportSource(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        },
          (error) => {
            alert(error.error);
          });
    }
  }
}
